import React from 'react'

export const useHover = (init = false) => {
  const [hover, setHover] = React.useState<boolean>(init)

  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)

  return {
    hover,
    actions: {
      onMouseEnter,
      onMouseLeave,
    },
  }
}
